import { combineEpics, ofType } from "redux-observable";
import * as RxOp from "rxjs/operators";
import * as Rx from "rxjs";
import * as S from "sanctuary";

import { resetOktaPassword } from "@/APIClient";
import { requestEpic } from "@/APIClient/observable.util";
import { editMyself } from "@/components/currentUser/CurrentUser.state";
import { DEFAULT_TIMEZONE } from "@/util/dates";
import { getAuthToken } from "@/util/session";
import {
  SUBMIT_PROFILE_FORM,
  submitChangePasswordFormFailure,
  CLOSE_PROFILE_FORM,
  OPEN_CHANGE_PASSWORD_FORM,
  handleResetPasswordUrl,
} from "./ProfilePage.state";

const buildResetOktaPasswordArgs = (state) => ({
  token: S.fromMaybe("")(getAuthToken(state)),
  userId: state.currentUser.id.value,
});

const buildEditProfileArgs = (state, oktaAuth) => ({
  firstName: state.profilePage.forms.profileForm.firstName.rawValue,
  lastName: state.profilePage.forms.profileForm.lastName.rawValue,
  timezone: DEFAULT_TIMEZONE,
  oktaAuth,
});

export const submitProfileUpdateEpic = (action$, state$) =>
  action$.pipe(
    ofType(SUBMIT_PROFILE_FORM),
    RxOp.flatMap(({ payload: { oktaAuth } }) =>
      Rx.of(editMyself(buildEditProfileArgs(state$.value, oktaAuth)))
    )
  );

export const openChangePasswordFormEpic = (action$, state$) =>
  action$.pipe(
    ofType(OPEN_CHANGE_PASSWORD_FORM),
    RxOp.flatMap(() =>
      requestEpic({
        requestMethod: resetOktaPassword,
        requestArgs: {
          ...buildResetOktaPasswordArgs(state$.value),
        },
        onSuccess: (res) =>
          Rx.of(handleResetPasswordUrl(res.value.resetPasswordUrl.value)),
        onFailure: () => Rx.of(submitChangePasswordFormFailure()),
      })
    )
  );
export const closeProfileFormEpic = (action$) =>
  action$.pipe(
    ofType(CLOSE_PROFILE_FORM),
    RxOp.mergeMap(({ payload: { history } }) =>
      Rx.of(() => history.push("/dashboard"))
    )
  );

export default combineEpics(
  submitProfileUpdateEpic,
  closeProfileFormEpic,
  openChangePasswordFormEpic
);
